module.exports = __webpack_public_path__ + "img/videoPoster1.b4f08511.jpg";